import { render, staticRenderFns } from "./SearchQuestions.vue?vue&type=template&id=bae17422"
import script from "./SearchQuestions.vue?vue&type=script&lang=js"
export * from "./SearchQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports